import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

export default class Lightbox {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const options = {
            Thumbs: {
                type: 'classic'
            },
            on: {
                done: (fancybox, slide) => {
                    const goToSlide = slide.index
                    this._elem.dispatchEvent(new CustomEvent('goToSlide', {'detail': goToSlide}))
                }
            }
        }
        Fancybox.bind('[data-fancybox="gallery"]', options)
    }
}



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Lightbox.js